import React from "react";
import { makeStyles } from "@material-ui/core";
import { Typography } from "@material-ui/core";

const useStyles = makeStyles(theme => ({
  header: {
    marginBottom: 0,
  },
}));

const InventoryHelpText = () => {
  const classes = useStyles();
  return (
    <div>
      <Typography variant="body2">
        Export a list of all titles found in your BiblioBoard Library
        organization.
      </Typography>
      <Typography className={classes.header} variant="body2">
        <strong>Filtering Options:</strong>
      </Typography>
      <ul>
        <li>Users can filter exports by:</li>
        <ul>
          <li>
            <strong>Organization:</strong> Generates a report of all inventory
            for a specific organization.
          </li>
          <li>
            <strong>Individual Module:</strong> Generates a report of all
            inventory items within a specified module.
          </li>
        </ul>
      </ul>
      <Typography className={classes.header} variant="body2">
        <strong>Inventory Data Fields:</strong>
      </Typography>
      <ul>
        <li>Each inventory item could include the following fields:</li>
        <ul>
          <li>MediaId</li>
          <li>Title</li>
          <li>Subtitle</li>
          <li>Module Title</li>
          <li>Type</li>
          <li>Volume</li>
          <li>Publisher Name</li>
          <li>ISBN</li>
          <li>DOI (Digital Object Identifier)</li>
          <li>Content Provider Collection</li>
          <li>Auxiliary Identifiers</li>
          <li>BISAC Codes</li>
        </ul>
      </ul>
    </div>
  );
};

export default InventoryHelpText;
